import Home from "./home/Home";
import Portfolio from "./portfolio/Portfolio";
import Writings from "./writings/Writings";
import Contact from "./contact/Contact";
import React from 'react';
import { Box } from "@mui/material";

export default function SinglePageRoutes({refs}) {
    return (
        <Box>
            <Home innerRef={refs.refAbout}/>
            <Writings innerRef={refs.refWritings}/>
            <Portfolio innerRef={refs.refPortfolio}/>
            <Contact innerRef={refs.refContact}/>
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                <img src="/alif-logo.png" alt="Alif" style={{ width: '200px', height: 'auto' }} />
            </Box>
        </Box>
    )
}
